import { ConditionOperator } from './ConditionField';

/**
 * Mirrors the backend ConditionRule shape exactly.
 * A rule is either a leaf (field + operator + value) or a logical group (and/or).
 */
export interface ConditionRule {
  field?: string;
  operator?: ConditionOperator;
  value?: string | number | boolean;
  and?: ConditionRule[];
  or?: ConditionRule[];
}

/** Returns true when the rule is a leaf (has a field; no and/or groups). */
export function isLeafRule(rule: ConditionRule): boolean {
  return rule.field !== undefined && rule.and === undefined && rule.or === undefined;
}

/** Serialises a ConditionRule to a JSON string. */
export function serializeCondition(rule: ConditionRule): string {
  return JSON.stringify(rule);
}

/**
 * Parses a JSON string back to a ConditionRule.
 * Returns null on any parse failure so callers never have to guard against thrown errors.
 */
export function deserializeCondition(json: string): ConditionRule | null {
  try {
    return JSON.parse(json) as ConditionRule;
  } catch {
    return null;
  }
}
